
const state = {
	user: {},
	permissions: [],
	modules: [],
	onlineUsers: [],
	unreadChatMessageCount: 0
}

const mutations = {
	setUser: (state, user) => {
		state.user = user
		state.unreadChatMessageCount = user.unreadChatMessageCount
	},
	setPermissions: (state, permissions) => {
		state.permissions = permissions
	},
	setModules: (state, modules) => {
		state.modules = modules
	},
	setOnlineUsers: (state, users) => {
		state.onlineUsers = users
	},
	setUserLanguage: (state, id) => {
		state.user.languageId = id
	},
	setUserImage: (state, image) => {
		state.user.image = image
	},
	setUserUnreadMessagesCount: (state, unreadChatMessageCount) => {
		state.unreadChatMessageCount = unreadChatMessageCount
	}
}

const actions = {}

const getters = {
	user: state => {
		return { ...state.user }
	},
	onlineUsers: state => state.onlineUsers,
	unreadChatMessageCount: state => state.unreadChatMessageCount
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}



// WEBPACK FOOTER //
// ./src/store/modules/User.js